/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.20.0
 * @since 1.20.0
 */

import { createListenerMiddleware } from '@reduxjs/toolkit';
import map from 'lodash/map';

import { IOptionItemProps } from '@components/common/Select/Select';
import { tableApi } from '@modules/table/store';

import { ICommonTranslation } from '../../../modules/internationalization/types';
import { API_SUBSCRIBER_TABLE_META } from '../constants';

export const tableSubscriberListenerMiddleware = createListenerMiddleware();

/*
* В запросе meta для таблицы заказов facets для фильтра-select приходят как массивы строк
* Массив строк нужно привести к стандартному виду label value
* Дл некоторых колонок значения устанавливаются на фронте
*/

export const tableSubscriberListenerStart = ({ select }: ICommonTranslation, context?: string) => {
    tableSubscriberListenerMiddleware.startListening({
        matcher: tableApi.endpoints.getTableMeta.matchFulfilled,
        effect: ({ payload }, listenerApi) => {
            const {
                /* Для колонок с типом фильтра-select необходимо массив строк привести к виду label & value */
                loyaltyStatus,
            } = (payload.facets || {});

            /* Для колонок "Предложения" необходимо добавить фильтры "Нет" и "Есть" */
            const campaignsOptions: IOptionItemProps[] = [
                /* Нет */
                { label: select.noExist, value: 0 },
                /* Есть */
                { label: select.exist, value: 1 },
            ];

            listenerApi.dispatch(
                // @ts-ignore
                tableApi.util.updateQueryData('getTableMeta', { url: API_SUBSCRIBER_TABLE_META, context }, (draft) => {
                    if (draft.facets) {
                        draft.facets.assistantCampaignsCount = campaignsOptions;
                        draft.facets.coordinatorCampaignsCount = campaignsOptions;
                        draft.facets.loyaltyStatus = map(loyaltyStatus, option => ({ label: option, value: option }));
                    }
                }),
            );
        },
    });
};
